/**
 * Trạng thái của item  queue copy data
 */
export default {
  None: 0, // Chờ trong database
  Processing: 1, // Đang xử lý
  Success: 2, // Thành công
  Error: 3, // Lỗi
  Cancel: 4, // Hủy
  NoData: 5, // Không có chứng từ sao chép
};
